import { render, staticRenderFns } from "./GlslShader2.vue?vue&type=template&id=707e1abe&"
import script from "./GlslShader2.vue?vue&type=script&lang=js&"
export * from "./GlslShader2.vue?vue&type=script&lang=js&"
import style0 from "./GlslShader2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports